import React, { useEffect } from "react";
import { validateProps } from "../../../../shared/props";
import { warnDeprecation } from "../../../../shared/warnDeprecation";
import { useViewport } from "../../../../styles";
import { ActionButton } from "../../../Buttons/ActionButton/ActionButton";
import { IconButton, IconButtonProps } from "../../../Buttons/IconButton/IconButton";
import { Callout, CalloutIconButtonProps } from "../../../Callout/Callout";
import { Text } from "../../../Text/Text";
import { GroupedListItemBaseProps } from "../../shared/props";
import { BaseFeedListItem, FeedListItemProps } from "../shared/BaseFeedListItem";

export interface DetailsFeedListItemProps extends FeedListItemProps {
    /**
     * First detail of additional text to show.
     */
    readonly firstDetail: string;

    /**
     * Second detail of additional text to show.
     */
    readonly secondDetail: string;

    /**
     * Props for the IconButton that will be shown on smaller viewports in lieu of the details.
     */
    readonly detailsIconButtonProps: CalloutIconButtonProps;

    /** Optional flag to indicate that the list item's contents are disabled */
    readonly disabled?: boolean;
}

export interface GroupedDetailsFeedListItemProps extends DetailsFeedListItemProps, GroupedListItemBaseProps { }

/** @deprecated Please use the new ListItem/MobileListItem with ListItemColumns instead. */
export const DetailsFeedListItem: React.FC<DetailsFeedListItemProps | GroupedDetailsFeedListItemProps> = ({
    image,
    text,
    firstDetail,
    secondDetail,
    detailsIconButtonProps,
    actionProps,
    disabled = false,
    ...otherProps
}) => {
    validateProps("DetailsFeedListItem", otherProps);

    useEffect(() => {
        warnDeprecation("DetailsFeedListItem has been deprecated, please use the new ListItem/MobileListItem with ListItemColumns instead.");
    }, []);

    const viewportType = useViewport();

    const callout = <Callout {...detailsIconButtonProps} calloutPosition="left-top" />;

    let actions: readonly JSX.Element[];
    if (["s", "m"].includes(viewportType)) {
        actions = [
            callout,
            <IconButton key="iconAction" disabled={disabled} {...(actionProps as IconButtonProps)} />
        ];
    } else if (viewportType === "l") {
        actions = [
            callout,
            <ActionButton key="buttonAction" disabled={disabled} {...actionProps} />
        ];
    } else {
        actions = [
            <Text key="first" disabled={disabled}>{firstDetail}</Text>,
            <Text key="second" disabled={disabled}>{secondDetail}</Text>,
            <ActionButton key="buttonAction" disabled={disabled} {...actionProps} />
        ];
    }

    return (
        <BaseFeedListItem
            image={image}
            actions={actions}
            disabled={disabled}
            {...otherProps}
        >
            <Text disabled={disabled}>{text}</Text>
        </BaseFeedListItem>
    );
};
